<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <!-- <el-form-item prop="type">
          <el-select v-model="listQuery.type" placeholder="请选择预约类型" clearable>
            <el-option v-for="item in dictionary['yylx']" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="nickname">
          <el-input v-model="listQuery.nickname" placeholder="请输入用户姓名" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <!-- <el-form-item prop="order_no">
          <el-input v-model="listQuery.order_no" placeholder="请输入订单号" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item> -->
        <el-form-item prop="site_id">
          <el-select v-model="listQuery.site_id" placeholder="请选择门店名称" filterable clearable>
            <el-option v-for="item in siteList" :key="item.value" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="coach_name">
          <el-input v-model="listQuery.coach_name" :disabled="listQuery.space_name || listQuery.type==1" placeholder="请输入教练名称" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="space_name">
          <el-input v-model="listQuery.space_name" :disabled="listQuery.coach_name || listQuery.type==2" placeholder="请输入场地名称" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="arrange_time">
          <el-date-picker v-model="listQuery.arrange_time" value-format="yyyy-MM-dd" type="date" placeholder="选择预约日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="listQuery.status" placeholder="请选择预约状态" filterable clearable>
            <el-option v-for="item in statusList" :key="item.value" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <!-- <div class="action-container">
      <el-button-group>
        <el-button v-auth="'Reservation.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
<el-button v-auth="'Reservation.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>

      </el-button-group>
    </div> -->
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <!-- <el-table-column align="center" prop="type_name" label="预约类型 "> </el-table-column> -->
      <el-table-column align="center" prop="user_name" label="用户姓名 "> </el-table-column>
      <el-table-column align="center" prop="site_name" label="门店名称 "> </el-table-column>
      <!-- <el-table-column align="center" prop="public_name" label="教练名称/场地名称 "> </el-table-column> -->
      <el-table-column align="center" prop="arrange_time" label="预约日期 "> </el-table-column>
      <!-- <el-table-column align="center" prop="arrange_time" label="预约时段 ">
        <template slot-scope="scope">
          <span>{{ scope.row.start_time }} - {{ scope.row.end_time }}</span>
        </template>>
      </el-table-column> -->
      <!-- <el-table-column align="center" prop="is_spell_site" label="是否拼场 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_spell_site==1" type="success">是</el-tag>
          <el-tag v-else type="danger">否</el-tag>
        </template>>
      </el-table-column> -->
      <el-table-column align="center" prop="status_name" label="预约状态 "> </el-table-column>
      <!-- <el-table-column align="center" prop="reach_num" label="场地人数 "> </el-table-column> -->
      <el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <!-- <el-button v-auth="'Reservation.delete'" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>
          <el-button v-auth="'Reservation.update'" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button> -->
          <el-button v-auth="'Reservation.browse'" plain icon="el-icon-tickets" type="success" size="mini" @click="detail(scopes.row)">详情</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog title="预约详情" :visible.sync="dialogFormVisible" width="1200px" top="7vh">
      <div style="margin:10px 0;height:66vh;overflow-y: scroll;">
        <el-card v-for="(item,index) in formData.lists" :key="index" style="margin:10px 0;">
          <el-descriptions :column="4">
            <el-descriptions-item label="用户昵称">{{ item.user_name }}</el-descriptions-item>
            <el-descriptions-item label="门店名称">{{ item.site_name }}</el-descriptions-item>
            <el-descriptions-item label="场地名称">{{ item.public_name }}</el-descriptions-item>
            <el-descriptions-item label="教练名称">{{ item.coach_name || '--' }}</el-descriptions-item>
            <el-descriptions-item label="预约日期">{{ item.arrange_time }}</el-descriptions-item>
            <el-descriptions-item label="预约时间段">{{ item.start_time }}-{{ item.end_time }}</el-descriptions-item>
            <el-descriptions-item label="状态" span="2">{{ item.status_name }}</el-descriptions-item>
            <el-descriptions-item label="邀约人数" span="2">{{ item.invite_num }}</el-descriptions-item>
            <el-descriptions-item label="拼场人数" span="2">{{ item.spell_num }}</el-descriptions-item>
            <el-descriptions-item v-if="item.invite && item.invite.length > 0" label="邀约列表" span="2">
              <el-card style="margin:10px 0">
                <el-table :data="item.invite" style="width: 400px">
                  <el-table-column prop="avatar" label="头像" width="50" align="center">
                    <template slot-scope="scope">
                      <img :src="base_url+scope.row.avatar" style="width: 40px;height: 40px;border-radius: 50%;">
                    </template>
                  </el-table-column>
                  <el-table-column prop="nickname" label="昵称" width="100" align="center"></el-table-column>
                  <el-table-column prop="gender" label="性别" width="50" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.gender==1" type="success">男</span>
                      <span v-else-if="scope.row.gender==2" type="danger">女</span>
                      <span v-else>未知</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" label="电话号" width="110" align="center"></el-table-column>
                  <el-table-column prop="status" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                      {{ ['','申请中','邀约成功','已拒绝','已过期','已核销'][scope.row.status] }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-descriptions-item>
            <el-descriptions-item v-if="item.spells && item.spells.length > 0" label="拼场列表" span="2">
              <el-card style="margin:10px 0">
                <el-table :data="item.spells" style="width: 400px">
                  <el-table-column prop="avatar" label="头像" width="50" align="center">
                    <template slot-scope="scope">
                      <img :src="base_url+scope.row.avatar" style="width: 40px;height: 40px;border-radius: 50%;">
                    </template>
                  </el-table-column>
                  <el-table-column prop="nickname" label="昵称" width="100" align="center"></el-table-column>
                  <el-table-column prop="gender" label="性别" width="50" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.gender==1" type="success">男</span>
                      <span v-else-if="scope.row.gender==2" type="danger">女</span>
                      <span v-else>未知</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" label="电话号" width="110" align="center"></el-table-column>
                  <el-table-column prop="status" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                      {{ ['','申请中','拼场成功','已拒绝','已过期','已核销'][scope.row.status] }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

      <!-- <el-form ref="dataForm" :rules="rules" :model="formData" label-width="120px" style="height:75vh;overflow-y: scroll;overflow-x:hidden;" :disabled="true">
        <el-alert title="预约信息" type="success" :closable="false" style="border-radius:0;margin-bottom:20px;"></el-alert>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="核销码">
              <FileList v-model="formData.qr_code" :limit="1" :read-only="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预约类型" prop="type_name">
              <el-input v-model="formData.type_name" placeholder="请输入预约类型"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="预约用户" prop="nickname">
              <el-input v-model="formData.nickname" placeholder="请输入预约用户"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号" prop="order_no">
              <el-input v-model="formData.order_no" placeholder="请输入订单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="预约门店" prop="site_name">
              <el-input v-model="formData.site_name" placeholder="请输入预约门店"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门店地址" prop="address">
              <el-input v-model="formData.address" placeholder="请输入门店地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-if="formData.type==1" label="预约场地" prop="public_name">
              <el-input v-model="formData.public_name" placeholder="请输入预约场地"></el-input>
            </el-form-item>
            <el-form-item v-else label="预约教练" prop="public_name">
              <el-input v-model="formData.public_name" placeholder="请输入预约教练"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预约时间" prop="arrange_time">
              <el-input v-model="formData.arrange_time" placeholder="请输入预约时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="是否拼场" prop="is_spell_site">
              <el-input v-model="formData.spell_site_name" placeholder="请输入是否拼场"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="formData.is_spell_site==1" label="拼场备注" prop="is_spell_message">
              <el-input v-model="formData.is_spell_message" type="textarea" placeholder="请输入拼场备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="预约状态" prop="status_name">
              <el-tag v-if="formData.status==1" type="warning">待使用</el-tag>
              <el-tag v-else-if="formData.status==2" type="success">已使用</el-tag>
              <el-tag v-else-if="formData.status==3" type="danger">已过期</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到场人数" prop="reach_num">
              <el-input v-model="formData.reach_num" placeholder="请输入到场人数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert title="邀约信息" type="success" :closable="false" style="border-radius:0;margin-top:20px;"></el-alert>
        <el-row :gutter="20">
          <el-table :data="inviteData" border style="width: 100%">
            <el-table-column prop="avatar" label="头像">
              <template slot-scope="scope">
                <el-image :src="scope.row.avatar" style="width: 100px;height: 100px;"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="姓名">
            </el-table-column>
            <el-table-column prop="status" label="邀约状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==1" type="warning">邀请中</el-tag>
                <el-tag v-else-if="scope.row.status==2" type="success">邀请成功</el-tag>
                <el-tag v-else-if="scope.row.status==3" type="danger">邀请失败</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-alert v-if="formData.is_spell_site==1" title="拼场信息" type="success" :closable="false" style="border-radius:0;margin-top:20px;"></el-alert>
        <el-row v-if="formData.is_spell_site==1" :gutter="20">
          <el-table :data="spellData" border style="width: 100%">
            <el-table-column prop="avatar" label="头像">
              <template slot-scope="scope">
                <el-image :src="scope.row.avatar" style="width: 100px;height: 100px;"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="姓名">
            </el-table-column>
            <el-table-column prop="status" label="拼场状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==1" type="warning">申请中</el-tag>
                <el-tag v-else-if="scope.row.status==2" type="success">拼场成功</el-tag>
                <el-tag v-else-if="scope.row.status==3" type="danger">拼场失败</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/reservation/reservation' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor'
// import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'
import siteapi from '@/api/site/site' // 和数据交互相关写在api 方便复用

export default {
  name: 'Reservation',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      // api接口方法
      api,
      // 校验
      rules: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      // 预约状态
      statusList: [
        { id: 1, name: '待使用' },
        { id: 2, name: '已使用' },
        { id: 3, name: '已过期' }
      ],
      dialogFormVisible: false,
      formData: [],
      siteList: [], // 门店
      // 字典参数
      dictionary: [],
      // 字典参数
      inviteData: [],
      spellData: []
    }
  },
  created() {
    this.loadData()
    // 门店列表
    this.siteListSearch()
    // 字典数据
    dict_data
      .Drop({
        sort: 'sort',
        order: 'asc',
        isPaginator: false,
        dict_code: 'yylx,'
      })
      .then((response) => {
        this.dictionary = response.data
      })
  },
  methods: {
    // 门店列表
    siteListSearch() {
      siteapi.getList().then((response) => {
        this.siteList = response.data
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999
      }
    },
    // 详情
    detail(data) {
      this.dialogFormVisible = true
      this.formData = data
      this.formData.spell_site_name = this.formData.is_spell_site === 1 ? '是' : '否'
      if (this.formData.is_spell_site === 1) {
        // 拼场信息
        this.getSpell(data)
      }
      // 邀约信息
      this.getinvite(data)
    },
    getSpell(data) {
      api.getspellList({ id: data.id }).then(response => {
        this.spellData = response.data
      })
    },
    getinvite(data) {
      api.getinviteList({ id: data.id }).then(response => {
        this.inviteData = response.data
      })
    }
  }
}
</script>
<style scoped>
.el-input.is-disabled .el-input__inner {
  color: black;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: black;
}
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
</style>
